import axios from "axios";
import { MessageBox } from "element-ui";
import { message } from "./message.js";
import router from "@/router";
import store from "@/store";
import { setRedirectPath } from "@/utils/auth";
// console.log("process.env.VUE_APP_BASE_API", process.env.VUE_APP_BASE_API);
// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  withCredentials: true, // send cookies when cross-domain requests
  timeout: 30000, // request timeout
});

// request interceptor
service.interceptors.request.use(
  (config) => {
    console.log('config',config);
     if (config){
      config.headers['Authorization'] = `Bearer ${localStorage.getItem("hpToken") || ""}`;
            config.params = {
                lang: localStorage.getItem("language"),
                ...config.params
            };
     }
    // if (config.method === 'post') {
    //     console.log('增加store_id');

    //     if (config.data && !config.data.store_id) {
    //         config.data = {
    //             store_id: JSON.parse(getToken()).store_id,
    //             ...config.data
    //         };
    //     }
    // } else if (config.method === 'get') {
    //     if (config.params && !config.params.store_id) {
    //         config.params = {
    //             store_id: JSON.parse(getToken()).store_id,
    //             ...config.params
    //         };
    //     }
    //   }
    return config;
  },
  (error) => {
    // do something with request error
    console.log(error); // for debug
    return Promise.reject(error);
  }
);

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  (response) => {
    // console.log(response,'-------------')
    const res = response.data;
    console.log('res',res);
    // if the custom code is not 20000, it is judged as an error.
    // Message.closeAll()
    if(response.config.url.indexOf("/captcha/flat")>-1){
      return res
    }
    // if(response.config.url.indexOf("/login")>-1){
    //   this.setToken("APP_CURRENT_ROLES");
    //   // return res
    // }

    // 如果没有 token，说明用户已退出登录，静默处理错误，不显示消息
    const hasToken = localStorage.getItem("hpToken");
    if (!hasToken &&
      response.config.url.indexOf("/checkverifycodebyaccount")==-1 &&
      response.config.url.indexOf("/check-token-status")==-1 &&
      response.config.url.indexOf("/checktokenstatus") == -1 &&
      response.config.url.indexOf("/mac/search") == -1 &&
      response.config.url.indexOf("/activation/") == -1 &&
      // response.config.url.indexOf("/public/") == -1 &&
      response.config.url.indexOf("/send-verify-binding-mac") == -1 &&
      response.config.url.indexOf("/request-song")==-1 &&
      response.config.url.indexOf("/song/") == -1 &&
       res.code !== 0&&(response.config.url.indexOf("/login")==-1&&
       response.config.url.indexOf("/send-verify")==-1&&
       response.config.url.indexOf("/register")==-1)) {
        message({
        message: res.message || "Error",
        duration: 2 * 1000,
        type: "error",
      });
        // Jika sedang berada di halaman activation atau song catalog, tidak perlu redirect ke login
        const currentPath = router.currentRoute.path;
        if (currentPath.startsWith('/activation') || currentPath.startsWith('/song-') || currentPath.startsWith('/artist-')) {
          return res;
        }
        // 保存当前页面路径
        const currentFullPath = router.currentRoute.fullPath
        if (currentFullPath !== '/' && currentFullPath !== '/login') {
          setRedirectPath(currentFullPath)
        }
        router.replace(`/login`);
      return res;
    }

    if (res.code !== 0 && res.code !== 995 && res.code !== 33 && res.code !== 1007 ) {
      // Message({
      //   message: res.message || 'Error',
      //   type: 'error',
      //   duration: 3 * 1000
      // })
      if (!response.config.silentError) {
        if(res.message.indexOf("verification link")==-1){
          message({
            message: res.message || "Error",
            duration: 2 * 1000,
            type: "error",
          });
        }
      }
      
      if (res.code === 841 || res.code === 842) {
        // 保存当前页面路径
        const currentPath = router.currentRoute.fullPath
        if (currentPath !== '/' && currentPath !== '/login') {
          setRedirectPath(currentPath)
        }
        // to re-login
        store.dispatch("user/resetToken").then(() => {
          router.replace(`/login`);
          store.dispatch("tagsView/delAllViews");
        });
      }
      // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
      if (
        res.code === 50008 ||
        res.code === 50012 ||
        res.code === 50014 ||
        res.code === 2 ||
        res.code === 941
      ) {
        // 保存当前页面路径
        const currentPath = router.currentRoute.fullPath
        if (currentPath !== '/' && currentPath !== '/login') {
          setRedirectPath(currentPath)
        }
        // to re-login
        MessageBox.confirm(
          "You have been logged out, you can cancel to stay on this page, or log in again",
          "Confirm logout",
          {
            confirmButtonText: "Re-Login",
            cancelButtonText: "Cancel",
            type: "warning",
          }
        ).then(() => {
          store.dispatch("user/resetToken").then(() => {
            location.reload();
          });
        });
      }
      return res;
      // return Promise.reject(new Error(res.message || "Error"));
    } else {
      return res;
    }
  },
  (error) => {
    // Abaikan jika request sengaja dibatalkan via CancelToken
    if (axios.isCancel && axios.isCancel(error)) {
      return Promise.reject(error);
    }

    console.log("err" + error); // for debug

    // If silentError is enabled in config, do not show pop-up error
    if (error.config && error.config.silentError) {
      return Promise.reject(error);
    }

    // 如果是因为没有 token 导致的错误，静默处理
    if (error.message === 'No token') {
      return Promise.reject(error);
    }

    // Message({
    // 	message: error.message,
    // 	type: 'error',
    // 	duration: 3 * 1000
    // })
    message({
      message: error.message,
      duration: 2 * 1000,
      type: "error",
    });

    return Promise.reject(error);
  }
);

export default service;
